import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Importing your CSS styles
import "./assets/fonts/fonts.css"; // Registers the Libre Franklin @font-face once, app-wide
import App from "./App"; // Importing the main App component
import $ from "jquery"; // Importing jQuery
import { AuthProvider } from "./components/AuthProvider";
import { BrowserRouter } from "react-router-dom";
import { installAuthFetch } from "./utils/auth";

// Every API call carries the login token (see utils/auth.js)
installAuthFetch();

// Making jQuery available globally
window.$ = $;
window.jQuery = $;

// Creating a root for rendering the app
const root = ReactDOM.createRoot(document.getElementById("root"));

// Rendering the App component
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
